import { Visitor } from 'graphql/generated/graphqlTypes';
import { useMemo } from 'react';
import { useDataGridSelectionWithPagination } from 'v2/components/DataGrid/useDataGridSelectionWithPagination';
import { AllUsersOverviewRow } from 'v2/pages/Users/Overview/components/useAllUsersColumns';

interface Params {
  visitors: Visitor[];
  filteredVisitors: Visitor[];
}

/** Selected users stay pinned in the table even when the filters exclude them. */
const useAllUsersSelection = ({ visitors, filteredVisitors }: Params) => {
  const allRows = useMemo<AllUsersOverviewRow[]>(
    () => visitors.map((visitor) => ({ id: visitor.id, visitor })),
    [visitors]
  );
  const filteredRows = useMemo<AllUsersOverviewRow[]>(
    () => filteredVisitors.map((visitor) => ({ id: visitor.id, visitor })),
    [filteredVisitors]
  );

  return useDataGridSelectionWithPagination({ allRows, filteredRows });
};

export default useAllUsersSelection;
